<template>
  <div v-if="product.faqsLang.length" class="product-faqs">
    <h2>{{ $t('fields.faqs') }}</h2>
    <p v-if="product.description && product.description.name" class="product-name">
      {{ product.description.name }}
    </p>
    <div class="faq-items">
      <product-faq v-for="(faq, index) in product.faqsLang" :key="index" :faq="faq" collapsable />
    </div>
  </div>
</template>

<script>
import ProductFaq from './ProductFaq'
export default {
  components: { ProductFaq },
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>
